import { Pipe } from '@angular/core';
import { isString } from '../utils/utils';
var EncodeURIPipe = (function () {
    function EncodeURIPipe() {
    }
    EncodeURIPipe.prototype.transform = function (input) {
        if (!isString(input)) {
            return input;
        }
        return encodeURI(input);
    };
    return EncodeURIPipe;
}());
export { EncodeURIPipe };
EncodeURIPipe.decorators = [
    { type: Pipe, args: [{
                name: 'encodeURI'
            },] },
];
/** @nocollapse */
EncodeURIPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=encode-uri.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/string/encode-uri.pipe.js
// module id = 277
// module chunks = 103